"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const QueryBuilderContext_1 = require("../QueryBuilderContext");
const lab_1 = require("@material-ui/lab");
const core_1 = require("@material-ui/core");
const QueryBuilderPluginConditionPicker = (_a) => {
    var { value, disabled, error, helperText, onChange, fullWidth, disableClearable, placeholder = 'Select a condtion' } = _a, props = __rest(_a, ["value", "disabled", "error", "helperText", "onChange", "fullWidth", "disableClearable", "placeholder"]);
    const { plugins } = (0, QueryBuilderContext_1.useQueryBuilderContext)();
    const conditions = plugins.reduce((results, p) => {
        results.push(...(p.conditions || []));
        return results;
    }, []);
    const selected = conditions.find(condition => condition.type === value);
    return (react_1.default.createElement(lab_1.Autocomplete, { disableClearable: disableClearable, fullWidth: fullWidth, forcePopupIcon: true, disabled: disabled, value: selected || null, options: conditions || [], getOptionLabel: option => option.name, onChange: (_, value) => onChange === null || onChange === void 0 ? void 0 : onChange(value || undefined), renderInput: params => (react_1.default.createElement(core_1.TextField, Object.assign({}, params, { fullWidth: true, size: 'small', variant: 'outlined', placeholder: placeholder, error: error, helperText: helperText }, props, { InputProps: Object.assign(Object.assign({}, params.InputProps), props.InputProps) }))) }));
};
exports.default = QueryBuilderPluginConditionPicker;
//# sourceMappingURL=QueryBuilderPluginConditionPicker.js.map